export default __webpack_public_path__ + "static/media/animationCircle.53352e0c.svg";